export const environment = {
  production: true,
  version: 'v1.first-commit',
  apiUrl: 'https://bothworldsapim.azure-api.net/napi/',
  avatar: 'https://eu.ui-avatars.com/api/?name=John+Doe',
  refreshTokenEndpoint: 'https://securetoken.googleapis.com/v1/token',
  insightsInstrumentationKey: '371167c7-bb3c-42c5-bac5-f20a4d4801e0',
  appInsights: {
    instrumentationKey: '371167c7-bb3c-42c5-bac5-f20a4d4801e0'
  },
  firebase: {
    apiKey: 'AIzaSyA7sqUJDc8BkugZ6c4isb1VDbYjNcuNHpg',
    authDomain: 'norder-ecd1a.firebaseapp.com',
    projectId: 'norder-ecd1a',
    storageBucket: 'norder-ecd1a.appspot.com',
    messagingSenderId: '329096662889',
    appId: '1:329096662889:web:78a098d7c9d4f6770bf7f8',
    measurementId: 'G-RLS0DS5XNW'
  },
};
